/* eslint-disable @typescript-eslint/no-empty-function */
import { Tokens } from 'types/api.types';
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'utils/constants';

export class TokenService {
	private static instance: TokenService;

	private constructor() {}

	static getInstance(): TokenService {
		if (!TokenService.instance) {
			TokenService.instance = new TokenService();
		}
		return TokenService.instance;
	}

	getAccessToken(): string | null {
		return localStorage.getItem(ACCESS_TOKEN);
	}

	getRefreshToken(): string | null {
		return localStorage.getItem(REFRESH_TOKEN);
	}

	setTokens(tokens: Tokens): void {
		localStorage.setItem(ACCESS_TOKEN, tokens.token);
		localStorage.setItem(REFRESH_TOKEN, tokens.refreshToken);
	}

	clearTokens(): void {
		localStorage.removeItem(ACCESS_TOKEN);
		localStorage.removeItem(REFRESH_TOKEN);
	}
}
